// Element's window may differ from the one within React instance
// if element rendered within iframe.
// See https://github.com/sanniassin/react-input-mask/issues/182
export function getElementDocument(
  element: HTMLElement | null,
): Document | null {
  return element?.ownerDocument || null;
}

export function getElementWindow(element: HTMLElement | null): Window | null {
  return getElementDocument(element)?.defaultView || null;
}

export function isDOMElement(element: HTMLElement): element is HTMLElement {
  const elementWindow = getElementWindow(element);
  return !!elementWindow && element instanceof HTMLElement;
}

export function isFunction(value: unknown): value is Function {
  return typeof value === 'function';
}

export function findLastIndex<T>(
  array: T[],
  predicate: (value: T, index: number) => boolean,
): number {
  for (let i = array.length - 1; i >= 0; i--) {
    const x = array[i];
    if (predicate(x, i)) {
      return i;
    }
  }
  return -1;
}

export function repeat(string: string, n: number = 1): string {
  let result = '';
  for (let i = 0; i < n; i++) {
    result += string;
  }
  return result;
}

export function toString(value: unknown): string {
  return `${value}`;
}
